import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { ChangeUserPasswordRequest } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  newPassword: string;
  passwordResetToken: string;
  expiryToken: string;
  userForm: FormGroup;

  passwordPattern = '(?=.*\\d)(?=.*[a-zA-Z]).{8,128}';

  get f() { return this.userForm.controls; }

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private accountServices: AccountService,
    private toastService: HotToastService,
    private router: Router,

  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      newPassword: ['', Validators.pattern(this.passwordPattern)],
      newPasswordConfirm: ['', Validators.required],
    });
    this.route.queryParams.subscribe(params => {
      this.passwordResetToken = params.p;
      this.expiryToken = params.t;
    });
  }

  onSubmit() {
    const forgotPasswordRequest: ChangeUserPasswordRequest = {
      expiryToken: this.expiryToken,
      newPassword: this.userForm.controls.newPassword.value,
      passwordResetToken: this.passwordResetToken,
    };
    this.accountServices.resetPassword(forgotPasswordRequest).subscribe(result => {
      this.toastService.success("Password Successfully Changed");
      this.router.navigate(['login']);
    },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          if (error.error.reasons) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
         else if (error.error.modelState.errors !== null) {
          const errors = error.error.modelState.errors as string[];
          errors.forEach(error => {
            this.toastService.warning(error);
          });
         }
        }
      });
  }

}
